import { render, staticRenderFns } from "./TaskListBase.vue?vue&type=template&id=b5cc6938&scoped=true&"
import script from "./TaskListBase.vue?vue&type=script&lang=js&"
export * from "./TaskListBase.vue?vue&type=script&lang=js&"
import style0 from "./TaskListBase.vue?vue&type=style&index=0&id=b5cc6938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cc6938",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/timefly-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5cc6938')) {
      api.createRecord('b5cc6938', component.options)
    } else {
      api.reload('b5cc6938', component.options)
    }
    module.hot.accept("./TaskListBase.vue?vue&type=template&id=b5cc6938&scoped=true&", function () {
      api.rerender('b5cc6938', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TaskListBase.vue"
export default component.exports